import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        wWidth: document.body.clientWidth,
        wHeight: document.body.clientHeight,
        isMobile: false,
        isApple: false,
        language: 'ZH_TW',
        testResult: null,
        last: null,
        isPreview: false,
        previewType: null,
        PCourseId: null,
        PCourseVersionId: null,
        auth: null,
        firstLoad: true
    },
    getters: {},
    mutations: {
        changeWidth(state, result) {
            state.wWidth = result;
            state.isMobile = result < 975 ? true : false;
        },
        changeHeight(state, result) {
            state.wHeight = result;
        },
        changeLan(state, language) {
            state.language = language == 'ZH_CN' ? 'Cn' : language == 'PT' ? 'Pt' : language == 'EN' ? 'En' : 'Tw'
        },
        changTestResult(state, result) {
            state.testResult = result;
        },
        changeLast(state, result) {
            state.last = result;
        },
        changePreview(state, result) {
            state.isPreview = result.isPreview;
            state.previewType = result.previewType;
            state.PCourseId = result.PCourseId;
            state.PCourseVersionId = result.PCourseVersionId;
            state.auth = result.auth;
        },
        changeFirstLoad(state, result) {
            state.firstLoad = result
        },
        changeIsApple(state, result) {
            state.isApple = result
        }
    }

})

export default store